import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import _ from 'lodash';
import { fromJS } from 'immutable';
import moment from 'moment';
import ClearIcon from '@material-ui/icons/Clear';

import 'react-responsive-carousel/lib/styles/carousel.min.css';

import styles from './styles';
import { showDialog, hideDialog } from '../../../redux/actions/dialogs';
import ReduxDialog from '../../Common/ReduxDialog/index';
import FirebaseImage from '../../Common/FirebaseImage/index';
import FirebaseCarousel from '../../Common/FirebaseCarousel/index';
import { TASK_PHOTOS_DIALOG } from '../../../redux/constants/dialogs';
import { getDialogContextValue } from '../../../redux/selectors';

class TaskPhotosDialog extends Component {
  static propTypes = {
    showDialog: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,

    task: PropTypes.object,
  };

  state = {};

  componentWillMount() {
  }

  renderImage(image) {
    console.log('img', image);
    return (<div key={image.id}>
      <FirebaseImage src={image.path} style={styles.image} showLoading={false}/>
      {this.renderLegend(image)}
    </div>);
  }

  renderLegend(image) {
    return (<div className="legend">
      {image.created && image.created.by ? <div>{image.created.by.name}</div> : null}
      {image.created && image.created.at ? <div>{moment(image.created.at).format('lll')}</div> : null}
    </div>);
  }

  render() {
    const { task } = this.props;
    console.log('task.images', task.images);
    const actions = [
      <Button
        variant="text"
        color="primary"
        onClick={() => this.props.hideDialog(TASK_PHOTOS_DIALOG)}
      >Close</Button>,
    ];

    const taskImages = _.values(task.images, {});
    const itemImages = _.flatten(_.values(task.items || {}).map((item) => _.values(item.images || {})));
    const qaQuestions = _.flatten(_.values(task.stages || {}).map((stage) => (stage.qa || {}).questions || {}));
    const qaImages = _.flatten(_.flatten(qaQuestions.map((questions) => _.values(questions))).map((question) => _.values(question.images || {})));

    console.log('taskImages', taskImages);
    console.log('itemImages', itemImages);

    return (
      <div style={styles.dialog}>
        <ReduxDialog
          name={TASK_PHOTOS_DIALOG}
          title="Task Photos"
          rightToolbar={<IconButton onClick={() => this.props.hideDialog(TASK_PHOTOS_DIALOG)}><ClearIcon
            color="white"/></IconButton>}
          actions={actions}
          modal
          autoScrollBodyContent
          onRequestClose={() => this.props.hideDialog(TASK_PHOTOS_DIALOG)}
          contentStyle={styles.dialog}
        >
          <Tabs>
            {taskImages && taskImages.length > 0 ? <Tab label="Task Photos">
              <FirebaseCarousel images={taskImages}/>
            </Tab> : null}
            {itemImages && itemImages.length > 0 ? <Tab label="Item Photos">
              <FirebaseCarousel images={itemImages}/>
            </Tab> : null}
            {qaImages && qaImages.length > 0 ? <Tab label="QA Photos">
              <FirebaseCarousel images={qaImages}/>
            </Tab> : null}
          </Tabs>
        </ReduxDialog>
      </div>
    );
  }
}

/*
 <div>
 <img src="https://images-na.ssl-images-amazon.com/images/I/71kgK6fAvtL._SL1500_.jpg" />
 <p className="legend">Legend 1</p>
 </div>
 <div>
 <img src="https://images10.newegg.com/ProductImage/24-106-003-08.jpg" />
 <p className="legend">Legend 2</p>
 </div>
 <div>
 <img src="http://www.usa.philips.com/c-dam/b2c/category-pages/pc-products-and-phones/monitors-cat/products/full-range-monitor.png" />
 <p className="legend">Legend 3</p>
 </div>
 */

function mapStateToProps(state) {
  // const task = state.get('tasks').get('task');
  const task = getDialogContextValue(state)(TASK_PHOTOS_DIALOG, 'task', fromJS({})).toJS();

  return {
    task,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    showDialog,
    hideDialog,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(TaskPhotosDialog);



// WEBPACK FOOTER //
// ./src/components/Tasks/TaskPhotosDialog/index.js